import {
    MobileWelcomeBannerStyled,
    MobileWelcomeBonusBannerTopUpButtonStyled
} from "./styled/MobileWelcomeBannerStyled";
import BinIcon from "../../../components/icon/Icon";
import { useBonusContext } from "../../../modules/Bonus/bonusContext";
import { useCallback } from "react";
import classNames from "classnames";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { useDispatch } from "react-redux";
import {
    setBonusPromocodeAction,
    setWelcomeApplyBonusAction,
    setWelcomeBannerOpenedAction
} from "../../../modules/Bonus/bonusesActions";
import { MOBILE_SLIDER_PAGES_IDS } from "../MobileSliderPages/mobileSliderPagesConstants";
import { Button } from "react-bootstrap";
import BonusTimeMobile from "../../../modules/Bonus/components/BonusTimeMobile/BonusTimeMobile";
import MobileBonusBanner from "./MobileBonusBanner";
import amountFormat from "../../../utils/amountFormat";
import { locationSlice } from '../../../modules/Location/locationReducer';

function MobileWelcomeBanner(props) {
    const {allowClose, className, short} = props;

    const dispatch = useDispatch();

    const {getLangPath} = useLangContext();
    const {bonusAvailablePercent, bonusAvailableSecondsLeft} = useBonusContext();

    const isFullAmount = bonusAvailableSecondsLeft > 0;

    const handleOpenTopUp = useCallback(() => {
        dispatch(setWelcomeApplyBonusAction(true));
        dispatch(setBonusPromocodeAction('welcome'));
        dispatch(locationSlice.actions.openLocationAction({
            name: MOBILE_SLIDER_PAGES_IDS.DEPOSIT
        }));
    }, [dispatch]);

    const handleBannerClick = useCallback(() => {
        if (!short) {
            return
        }
        handleOpenTopUp()
    }, [short, handleOpenTopUp]);

    const handleClose = useCallback(() => {
        dispatch(setWelcomeBannerOpenedAction(false));
    }, [dispatch]);

    return <MobileWelcomeBannerStyled className={classNames(className, {
        'full-amount': isFullAmount,
        'short': !!short
    })}>
        <MobileBonusBanner
            allowClose={allowClose && bonusAvailableSecondsLeft <= 0}
            description={getLangPath(`bonus.welcome.${isFullAmount ? 'double_first_deposit' : 'first_deposit_bonus'}`)}
            rightComponent={bonusAvailableSecondsLeft > 0 ? <BonusTimeMobile/> : undefined}
            className={className}
            handleClose={handleClose}
            onBannerClick={handleBannerClick}
            title={amountFormat(bonusAvailablePercent, 0, null, false, {
                currencyAfter: '%',
                withSign: true,
            })}
        >
            {
                !short && <Button
                    onClick={handleOpenTopUp}
                    variant={'primary'}
                    as={MobileWelcomeBonusBannerTopUpButtonStyled}
                    size={'sm'}
                >
                    <BinIcon name={'IcPlus'}/>
                    <span className={'ms-2'}>{getLangPath('lite_version.home.top_up')}</span>
                </Button>
            }
        </MobileBonusBanner>
    </MobileWelcomeBannerStyled>
}

export default MobileWelcomeBanner;
